import { colors } from "../../constants/colors";

export const customMultiSelectStyle = {
  container: (provided: any, state: any) => ({
    ...provided,
    clear: "both",
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    height: "auto",
    paddingRight: "4px",
    boxShadow: "none",
    border: state.isFocused
      ? `1px solid ${colors.ceruleanBlue}`
      : state.isDisabled? `${colors.warmWhite}` :`1px solid ${colors.newWhisper}`,
      
    "&:hover": {
      border: state.isFocused
        ? `1px solid ${colors.ceruleanBlue}`
        : `1px solid ${colors.newWhisper}`,
    },
    backgroundColor: state.isDisabled ? `${colors.warmWhite}` : `${colors.white}`,
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor:`${colors.white}`,
    border: "0",
    boxShadow: "none",
    display: "flex",
    alignItems: "center",
    "label": {
      fontFamily: "Lato",
      fontSize: "14px",
      fontStretch: "normal",
      fontStyle: "normal",
      fontWeight: "400",
      letterSpacing: "normal",
      lineHeight: "normal",
      margin: "1px 0",
      color: state.isFocused ? colors.ceruleanBlue : colors.charcoalGrey,
    },
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: colors.white,
    border: `1px solid ${colors.newWhisper}`,
    borderRadius: "4px",
    boxShadow: `0 2px 6px 0 rgb(${colors.blackRGB} / 1%)`,
    zIndex: "15",
    height: "auto",
    margin: "4px 0",
    minWidth: "30px",
    padding: "5px 0",
    textAlign: "left",
  }),
  input: (provided: any, state: any) => ({
    ...provided,
    fontFamily: "Lato",
    fontSize: "14px",
    fontStretch: "normal",
    fontStyle: "normal",
    fontWeight: "400",
    letterSpacing: "normal",
    lineHeight: "0.71",
    color: colors.charcoalGrey,
    border: "0",
    "&:focus": {
      border: "0",
    },
    "& input": {
      border: "0",
      "&:focus": {
        border: "0 !important",
      },
    },
  }),
  multiValue: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "var(--approx-alice-blue)",
    border: `1px solid ${colors.ceruleanBlue}`,
    borderRadius: "4px", // Rounded corners
    display: "flex",
    alignItems: "center",
    padding: "2px 6px", // Padding around the text
    margin: "2px",
  }),

  // Style for the label text within the tag
  multiValueLabel: (provided: any, state: any) => ({
    ...provided,
    color: colors.charcoalGrey,
    fontSize: "14px",
    fontWeight: "500",
  }),

  // Style for the remove icon (X button) within the tag
  multiValueRemove: (provided: any, state: any) => ({
    ...provided,
    color: colors.charcoalGrey,
    cursor: "pointer",
    ":hover": {
      backgroundColor: "var(--approx-alice-blue)",
    },

  }),
  valueContainer: (provided: any, state: any) => ({
    ...provided,
    padding: "0 12px",
    margin: "0",
  }),
  placeholder: (provided: any, state: any) => ({
    ...provided,
    fontFamily: "Lato",
    fontSize: "14px",
    fontStretch: "normal",
    fontStyle: "normal",
    fontWeight: "normal",
    letterSpacing: "normal",
    lineHeight: "normal",
    color: `rgba(${colors.charcoalGreyRGB}, 0.55)`,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  noOptionsMessage: (provided: any, state: any) => ({
    ...provided,
    fontFamily: "Lato",
    fontSize: "14px",
    fontStretch: "normal",
    fontStyle: "italic",
    fontWeight: "normal",
    letterSpacing: "normal",
    lineHeight: "normal",
    color: colors.battleshipGrey,
    textAlign: "left",
    padding: "10px 0 20px 0",
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided,
    display: "none",
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: colors.slate,
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
    "&:hover": {
      color: colors.slate,
    },
    "& svg": {
      width: "12px",
      height: "12px",
      marginRight: "0px",
      "& path": {
        fill: colors.slate,
      },
    },
  }),
};
